const { createApp, h } = Vue
const rootEl = document.getElementById('productApp');
const apiImageComponent = {
    data() {
        return {
            apiImage: null,
            isApi: true,
            loading: false
        }
    },
    props: {
        item: Object,
        shopify: Object,
        startingImage: Number,
        images: Array
    },
    created() {
        if(this.item && this.item.hasOwnProperty('url')) {
            if(this.item.update === true) {
                if(sessionStorage.getItem('adobe-image-'+this.item.id)) {
                    this.$emit('downloadImage',sessionStorage.getItem('adobe-image-'+this.item.id));
                } else {
                this.loading = true
                let url = this.remoteApiUrl + 'shopify/api/download?id='+this.item.id;
                axios.get(url).then((response) => {
                    if(response.data && response.data.url) {
                            sessionStorage.setItem('adobe-image-'+this.item.id, response.data.url);
                            this.$emit('downloadImage',response.data.url);
                    }
                }).finally(() => {
                    this.loading = false;
                });
            }
            }
        } else {
            this.isApi = false
        }
    },
    emits: ['openQuickview','downloadImage','changeImage'],
    computed: {
        currentImage() {
            if(this.startingImage !== null
                && this.startingImage >= 0
                && this.startingImage < this.images.length) {
                return this.images[this.startingImage];
            }
        },
        imageClass() {
            return {
                'loading': this.loading,
                'vertical': this.item.ratio <= 0.7,
                'square': this.item.ratio > 0.7 && this.item.ratio <= 1.3,
                'horizontal': this.item.ratio > 1.3 && this.item.ratio < 2,
                'panoramic': this.item.ratio >= 2
            }
        }
    },
    methods: {
        open() {
            this.$emit('openQuickview')
        },
        nextImage() {
            let active = this.startingImage + 1;
            if(active >= this.images.length) {
                active = 0;
            }
            this.activateImage(active);
        },
        prevImage() {
            let active = this.startingImage - 1;
            if(active < 0) {
                active = this.images.length - 1;
            }
            this.activateImage(active);
        },
        activateImage(imageIndex) {
            this.$emit('changeImage', imageIndex);
        }
    },
    template: `<div class="product-thumbs" id="thumbnails-wrapper" :class="{'d-none d-xl-block':images.length === 1}">
        <ul class="slick-dots">
            <li :class="{'slick-active':index === this.startingImage}" v-for="(image, index) in images">
                <a href="#" @click.prevent="activateImage(index)"><img :src="image.src"></a>
            </li>
        </ul>
    </div>
    <div class="product-main-img">
        <div class="gallery-wrapper slick-initialized slick-slider slick-dotted">
            <button v-if="images && images.length > 1" type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" @click.prevent="prevImage()">Previous</button>
            <div class="item">
                <img class="img-responsive" alt="" :src="currentImage.src">
            </div>
            <button v-if="images && images.length > 1" type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" @click.prevent="nextImage()">Next</button>
            <a href="#" class="quickview" @click.prevent="open">View Larger</a>
        </div>
    </div>
    `,
}
const productApp = Vue.createApp({
    components: {
        'api-image': apiImageComponent,
        'api-similar-works': SimilarWorks,
        'wishlistlink': wishlistLink,
        'faqs': Faqs,
        'materials-compare': materialsModalCompare
        // 'additional-info': AdditionalInfo
    },
    data() {
        return {
            items: [],
            item: null,
            qty: 1,
            shopify: {},
            variants: {},
            variant: null,
            size: null,
            options: {
              'size': [],
              'material': []
            },
            material: null,
            instructionsOpen: false,
            tabs: {
                "shipping": {
                    "collapsed": true
                },
                "installation": {
                    "collapsed": true
                },
                "description": {
                    "collapsed": true
                }
            },
            loading: false,
            loaded: false,
            errors: {},
            downloadInterval: null,
            selectedImage: 0,
            materialsModalOpen: false,
            calcModalOpen: false,
            discount: (this.partnerDiscount && window.customerIsPartner) ? this.partnerDiscount : this.autoDiscount,
            wallHeight: {
                'ft': null,
                'in': null
            },
            wall: {
                'ft': null,
                'in': null
            },
            walls: [
                {
                    'ft': null,
                    'in': null
                }
            ],
            panels: null,
            calculatedSize: null,
            calculated: false,
            validated: false,
            staticImages: []
        }
    },
    props: ['type','shopifyType','autoDiscount','partnerDiscount'],
    created() {
        this.cartNotification = document.querySelector('cart-notification');
        this.getShopifyData()
        if(this.shopifyType === 'ShopifyWallpaper') {
            this.getShopifyItem()
        } else {
            this.getItem()
        }
        this.getStaticImages()
    },
    mounted () {
        this.observePdp();
    },
    computed: {
        rollSizes() {
            // Parse the available (non-sample) roll options into { label, width, length } in feet.
            // Size labels arrive HTML-escaped from Liquid (e.g. "2&#39; x 9&#39; Roll"), so decode
            // before pulling the numbers out — otherwise the digits inside "&#39;" corrupt the parse.
            return this.options.size.map((label) => {
                const decoded = this.decodeEntity(label);
                const parts = decoded.split('x').map(part => Number(part.replace(/[^\d.]/g, '')));
                return {
                    'label': label,
                    'width': parts[0] || 0,
                    'length': parts[1] || 0
                };
            }).filter(size => size.width > 0 && size.length > 0);
        },
        maxRollLength() {
            // The longest roll we sell — the tallest wall the calculator can cover.
            return this.rollSizes.reduce((max, size) => size.length > max ? size.length : max, 0);
        },
        heightFeet() {
            const ft = Number(this.wallHeight.ft) || 0;
            const inch = Number(this.wallHeight.in) || 0;
            return ft + (inch / 12);
        },
        totalWidthFeet() {
            return this.walls.reduce((total, wall) => {
                const ft = Number(wall.ft) || 0;
                const inch = Number(wall.in) || 0;
                return total + ft + (inch / 12);
            }, 0);
        },
        heightExceedsMax() {
            return this.heightFeet > 0 && this.maxRollLength > 0 && this.heightFeet > this.maxRollLength;
        },
        displaySize() {
            // Decode the escaped label and drop the trailing "Roll", e.g. "2&#39; x 9&#39; Roll" -> "2' x 9'".
            return this.calculatedSize ? this.decodeEntity(this.calculatedSize).replace(/\s*roll\s*/i, ' ').trim() : '';
        },
        heightInvalid() {
            // Current-state height problem: taller than any roll, or not entered.
            return this.heightExceedsMax || this.heightFeet <= 0;
        },
        heightErrorMessage() {
            if(this.heightExceedsMax) {
                return `This wallpaper has a max height of ${this.maxRollLength}ft. `;
            }
            if(this.validated && this.heightFeet <= 0) {
                return 'Height must be greater than 0.';
            }
            return '';
        },
        price() {
            return this.variant.price * this.qty;
        },
        specialPrice() {
            return (this.variant.price * this.qty) * (1 - (Number(this.discount) / 100));
        },
        images() {
            let imgs = []
            this.selectedImage = 0;
            const renderedSize = this.item.size || "small";
            if(this.item && this.item.url) {
                //imgs.push({'src':this.previewUrl + this.item.url});
                //this.canvasUrls[renderedSize].forEach((canvasUrl) => {
                //    imgs.push({'src': canvasUrl + this.item.url});
                //});
                //if(typeof window.canvasImageBack != 'undefined' && window.canvasImageBack != null) imgs.push({'src': window.canvasImageBack});
                //if(typeof window.canvasImageSide != 'undefined' && window.canvasImageSide != null) imgs.push({'src': window.canvasImageSide});
                const mainImageFIlename = this.item.url.split('/').pop().split('?')[0];
                imgs.push({'src':this.item.url, 'filename': mainImageFIlename});
                if(this.item.hasOwnProperty('gallery') && this.item.gallery.length > 0) {
                    this.item.gallery.forEach((i) => {
                        const galleryImage = i.hasOwnProperty('url') && i.url ? i.url : i;
                        const galleryImageFilename = galleryImage.split('/').pop().split('?')[0];
                        if(!imgs.find(img => img.filename === galleryImageFilename)) {
                            imgs.push({'src': galleryImage, 'filename': galleryImageFilename});
                        }
                    });
                }
            }
            for (const image of this.staticImages) {
                imgs.push({'src':image.src});
            }
            return imgs
        },
        materialPrices() {
            const prices = {};
            if(this.item && this.options.material.length > 0) {
                this.options.material.forEach((material) => {
                    const variant = this.variants.find((v) => {
                        return (
                            v.size === this.size &&
                            v.material === material.label
                        );
                    });
                    if(variant) {
                        prices[material.code] = {
                            'price': variant.price * this.qty
                        };
                        if(Number(this.discount) > 0) {
                            prices[material.code]['special'] = prices[material.code]['price'] * (1 - (Number(this.discount) / 100));
                            prices[material.code]['discount'] = `${this.discount}% off`;
                        }
                    }
                })
            }
            return prices;
        },
        cartLoading() {
            return store.getters['cartPopup/loading'];
        },
        showComparePopup() {
            return store.getters['modal/showComparePopup'];
        },
    },
    watch: {
        'qty': {
            handler(newValue, oldValue) {
                if(!Number.isInteger(newValue)) {
                    this.qty = oldValue;
                }
            }
        },
        'size': {
            handler(newValue, oldValue) {
                this.updateVariant();
            }
        },
        'material': {
            handler(newValue, oldValue) {
                this.updateVariant();
            }
        },
        materialsModalOpen(newState,oldState) {
            if(newState) {
                document.body.classList.add('overflow-hidden')
            } else {
                document.body.classList.remove('overflow-hidden')
            }
        },
        calcModalOpen(newState,oldState) {
            if(newState) {
                document.body.classList.add('overflow-hidden')
            } else {
                document.body.classList.remove('overflow-hidden')
            }
        },
        showComparePopup(newState,oldState) {
            if(newState) {
                document.body.classList.add('overflow-hidden')
            } else {
                document.body.classList.remove('overflow-hidden')
            }
        },
    },
    methods: {
        updateQty(dir) {
            if(dir === 'minus') {
                this.qty = this.qty < 2 ? 1 : this.qty - 1;
            } else {
                this.qty++;
            }
        },
        changeImage(index) {
            this.selectedImage = index;
        },
        downloadImage(image) {
            this.item.url = image;
        },
        openQuickview() {
            const modalBody =`<div class="image"><img src="${this.images[this.selectedImage].src}" alt=""></div>`;
            store.dispatch('modal/set', {
                'modalBody': modalBody
            })
            this.openModal();
        },
        openModal() {
            store.dispatch('modal/open')
        },
        closeModal() {
            store.dispatch('modal/close')
        },
        openCompareModal() {
            store.dispatch('modal/openComparePopup');
        },
        closeCompareModal() {
            store.dispatch('modal/closeComparePopup');
        },
        addWall() {
            this.walls.push({ 'ft': null, 'in': null });
        },
        removeWall(index) {
            if(index > 0) {
                this.walls.splice(index, 1);
            }
        },
        calculate() {
            this.validated = true;
            const height = this.heightFeet;
            const totalWidth = this.totalWidthFeet;
            // Block only on a height problem or no usable width at all. Blank individual walls are
            // flagged inline (see wallHasError) but don't block; the estimate uses the walls that
            // do have a width, and any prior estimate is left in place.
            if(this.heightInvalid || totalWidth <= 0) {
                return;
            }
            // Auto-pick the shortest roll long enough for the tallest wall (cheapest that fits).
            const fitting = this.rollSizes
                .filter(size => size.length >= height)
                .sort((a, b) => a.length - b.length);
            if(fitting.length === 0) {
                return;
            }
            const roll = fitting[0];
            // Rolls are the panel width (2'); each panel covers one full-height column.
            let panels = Math.ceil(totalWidth / roll.width);
            // Always add a 10% overage so the customer isn't left short on material.
            panels = Math.ceil(panels * 1.1);
            this.panels = panels;
            this.calculatedSize = roll.label;
            this.calculated = true;
        },
        wallHasError(index) {
            // Flag a wall whose width is blank/zero — only after the first Calculate attempt.
            if(!this.validated) {
                return false;
            }
            const wall = this.walls[index];
            if(!wall) {
                return false;
            }
            return ((Number(wall.ft) || 0) + (Number(wall.in) || 0) / 12) <= 0;
        },
        selectAndClose() {
            if(!this.panels || !this.calculatedSize || this.heightInvalid) {
                return;
            }
            // Apply both the auto-picked roll size and the panel quantity to the product form.
            this.qty = this.panels;
            this.size = this.calculatedSize;
            this.calcModalOpen = false;
        },
        updateVariant() {
            if(this.size && this.material) {
                this.variant = this.variants.find((variant) => {
                    return (
                        variant.size === this.size &&
                        variant.material === this.material
                    );
                })
            }
        },
        getShopifyData() {
            try {
                this.shopify = JSON.parse(document.getElementById('product-json').textContent);
                // this.shopify.featured_image may be relative path, or missing https:. Add it if needed
                if(this.shopify.featured_image && this.shopify.featured_image.indexOf('http') !== 0) {
                    if(this.shopify.featured_image.indexOf('//') === 0) {
                        this.shopify.featured_image = 'https:' + this.shopify.featured_image;
                    } else if(this.shopify.featured_image.indexOf('/') === 0) {
                        this.shopify.featured_image = 'https://www.limitlesswalls.com' + this.shopify.featured_image;
                    } else {
                        this.shopify.featured_image = 'https://www.limitlesswalls.com/' + this.shopify.featured_image;
                    }
                }
                this.variants = JSON.parse(document.getElementById('product-sizes-json').textContent);
                const data = JSON.parse(document.getElementById('product-materials-json').textContent);
                this.variants.forEach(v => {
                    if(this.options.size.indexOf(v.size) === -1 && v.size.indexOf('Sample') === -1) {
                        this.options.size.push(v.size);
                    }
                    if(!this.options.material.find(m => m.label === v.material)) {
                        this.options.material.push({
                            'label': v.material
                        });
                    }
                });
                this.options.material.forEach((material, index) => {
                    const found = data.materials.find(m => m.label === material.label);
                    if(found) {
                        this.options.material[index] = found;
                    }
                })
                this.options.material.sort((a, b) => {
                    return a.code.localeCompare(b.code);
                });
                this.variant = this.variants[0];
                this.size = this.variant.size;
                this.material = this.variant.material;
            } catch (e) {
                console.error(e)
            }
        },
        getShopifyItem() {
            const img = new Image();
            img.onload = () => {
                const width = img.width
                const height = img.height
                this.item = {
                    "sku": this.shopify.sku,
                    "id": this.shopify.id,
                    "item_number": this.shopify.item_number,
                    "handle": this.shopify.handle,
                    "url": this.shopify.featured_image,
                    "url_key": this.shopify.handle,
                    "title": this.shopify.title,
                    "meta_title": this.shopify.title,
                    "meta_description": this.shopify.description,
                    "description": this.shopify.description,
                    "update": false,
                    "type": this.type,
                    "shopify": true,
                    "gallery": this.shopify.images,
                    "instructions": '',
                    "item_number": this.shopify.item_number,
                    "imageWidth": width,
                    "imageHeight": height,
                }
                this.updateMetas(this.item);
                this.loaded = true;
            }
            img.src = this.shopify.featured_image
        },
        getItem() {
            let image = null
            let title = 'Wallpaper'
            let categoryName = null
            let updateImage = false
            let imageId = null
            let urlKey = null
            let productId = null
            const params = new URLSearchParams(window.location.search);
            const url = new URL(window.location);
            if(params.has('imageId') === true) {
                imageId = parseInt(params.get('imageId'))
            } else {
                let urlId = url.pathname.replace('/products/wallpaper/','');
                if(/^\d+$/.test(urlId)) {
                    imageId = parseInt(urlId);
                } else {
                    urlKey = urlId;
                    if(urlKey.indexOf('_') >= 0) {
                        let splitUrlKey = urlKey.split('_');
                        urlKey = splitUrlKey[0];
                        if(/^\d+$/.test(splitUrlKey[1])) {
                            productId = parseInt(splitUrlKey[1]);
                        }
                    }
                }

            }
            if(params.has('updateImage') === true) {
                updateImage = true
            }
            if(params.has('image') === true) {
                try {
                    image = atob(params.get('image'))
                } catch (e) {
                    console.error(e);
                }
            }
            if(params.has('title') === true) {
                try {
                    title = this.capitalize(atob(params.get('title')))
                    title = title.replace(/\./g, ' ');
                } catch (e) {
                    console.error(e);
                }
            }
            if(params.has('category') === true) {
                try {
                    categoryName = this.capitalize(atob(params.get('category')))
                    categoryName = categoryName.replace(/\./g, ' ');
                } catch (e) {
                    console.error(e);
                }
            }

            // API Product
            if(image) {
                // can't have wallpapers from API, redirect to /products/mural
                window.location.href = '/products/mural/'+imageId;
                return false;
                const img = new Image();
                img.onload = () => {
                    this.item = {
                        "id": imageId,
                        "url": image,
                        "title": title,
                        "categories": categoryName ? [{'name': categoryName}] : [],
                        "update": updateImage,
                        "type": this.type,
                        "instructions": '',
                    }
                    this.fetchCategory();
                    this.updateMetas(this.item);
                    this.loaded = true;
                }
                img.src = image
            // Magento Product
            } else if(urlKey) {
                let url = this.remoteApiUrl + 'shopify/api/load?isAjax=1&type=wallpaper&url='+urlKey;
                if(productId) {
                    url += '&entity_id=' + productId;
                }
                axios.get(url).then((response) => {
                    if(response.data && response.data.product) {
                        const product = response.data.product;
                        if(product.hasOwnProperty('type') && product['type'] !== 'wallpaper') {
                            // redirect to correct typy
                            window.location.href = '/products/'+product['type']+'/'+product['url'];
                            return false;
                        }
                        const img = new Image();
                        img.onload = () => {
                            this.item = {
                                "entity_id": product.entity_id,
                                "sku": product.sku,
                                "similar_categories": product.similar_categories,
                                "categories": product.similar_categories,
                                "id": product.id,
                                "url": product.thumbnail_url,
                                "url_key": productId ? urlKey+'_'+productId : urlKey,
                                "title": product.title,
                                "meta_title": product.meta_title,
                                "meta_description": product.meta_description,
                                "additional_info": product.additional_info,
                                "description": product.description,
                                "update": false,
                                "type": this.type,
                                "gallery": product.images,
                                "instructions": ''
                            }
                            this.updateMetas(this.item);
                            this.loaded = true;
                        }
                        img.src = product.thumbnail_url
                    } else {
                        window.location.href = '/collections/wallpaper';
                        return false;
                    }
                }).finally(() => {

                });
            // API Product with Image ID only
            } else if(imageId) {
                // can't have wallpapers from API, redirect to /products/mural
                window.location.href = '/products/mural/'+imageId;
                return false;
                let url = this.remoteApiUrl + 'shopify/api/get?isAjax=1&type=wallpaper&id='+imageId;
                axios.get(url).then((response) => {
                    if(response.data && response.data.product) {
                        const product = response.data.product;
                        const img = new Image();
                        img.onload = () => {
                            const width = img.width
                            const height = img.height
                            const imageRatio = width / height
                            this.item = {
                                "id": product.id,
                                "url": product.thumbnail_url,
                                "title": product.title,
                                "categories": product.hasOwnProperty('category') && product.category ? product.category : [],
                                "update": false,
                                "type": this.type,
                                "instructions": '',
                            }
                            this.updateMetas(this.item);
                            this.loaded = true;
                        }
                        img.src = product.thumbnail_url
                    }
                }).catch((error) => {
                    let filters = this.cloneObject(this.xApiFilters);
                    filters['search_parameters']['thumbnail_size'] = 1000;
                    filters['search_parameters']['media_id'] = imageId;
                    fetch(this.adobeApiSearchUrl, {method: 'POST', body: JSON.stringify(filters), headers: this.fetchHeaders})
                        .then((response) => response.json())
                        .then((response) => {
                            if(response && response.files && response.files.length > 0) {
                                const product = response.files[0];
                                const img = new Image();
                                img.onload = () => {
                                    const width = img.width
                                    const height = img.height
                                    const imageRatio = width / height
                                    this.item = {
                                        "id": product.id,
                                        "url": product.thumbnail_url,
                                        "title": product.title,
                                        "categories": [],
                                        "update": false,
                                        "type": this.type,
                                        "instructions": '',
                                    }
                                    this.updateMetas(this.item);
                                    this.loaded = true;
                                }
                                img.src = product.thumbnail_url
                            }
                        })
                }).finally(() => {

                });
            }
        },
        fetchCategory() {
            if(this.item && this.item.hasOwnProperty('id') && this.item.id) {
                fetch(this.adobeApiMetadataUrl, {method: 'POST', body: JSON.stringify({'id': this.item.id}), headers: this.fetchHeaders})
                    .then((response) => response.json())
                    .then((response) => {
                        if(response && response.hasOwnProperty('files') && response['files'] && response['files'].length > 0) {
                            response['files'].forEach((resultFile) => {
                                if(resultFile.hasOwnProperty('id') &&
                                    resultFile.id === this.item.id &&
                                    resultFile.hasOwnProperty('category') &&
                                    resultFile['category'] &&
                                    resultFile['category'].hasOwnProperty('name'))
                                {
                                    this.item.categories.push(resultFile['category']);
                                }
                            })
                        }
                    })
                    .catch((error) => console.error(error));
            }

        },
        openSampleModal() {
            if(!this.item) {
                return false;
            }
            store.dispatch('samplePopup/set', {'item': this.item, 'croppedFile': null, 'files': null});
            store.dispatch('samplePopup/open');
        },
        addToCart() {
            this.errors = {};
            if(isNaN(this.qty) || this.qty < 1 || !this.variant) {
                this.errors['cart'] = 'Please select wallpaper size';
                return false;
            }
            let properties = {
                '_id': this.shopify.id,
                '_entity_id': null,
                '_sku': this.item.hasOwnProperty('sku') && this.item.sku ? this.item.sku : this.item.id,
                '_original_image': this.shopify.featured_image,
                '_product_url': window.location.href.split('?')[0],
                '_handle': this.shopify.handle,
                '_name': this.shopify.title,
                '_quantity': this.qty,
                '_type': this.type,
                'Size': this.decodeEntity(this.size),
                'Materials': this.decodeEntity(this.material)
            };
            if(this.item.instructions && this.item.instructions !== '') {
                properties['Comments'] = this.item.instructions;
            }

            const data = {
                items: [{
                    id: this.variant.id,
                    quantity: Math.round(this.qty),
                    properties: properties
                }],
                'sections': this.cartNotification.getSectionsToRender().map((section) => section.id),
                'sections_url': window.location.pathname
            };
            store.dispatch('cartPopup/buy', {'cart': data,'product': this.shopify});
            const productUrl = window.location.href.split('?')[0];
            const productData = {
                'pageType' : 'Add to Cart',
                'event'    : 'Add to Cart',
                'products': [{
                    'id': this.shopify.id,
                    'sku': this.shopify.id,
                    'productType': this.shopify.type,
                    'name': this.shopify.title,
                    'price': document.getElementById('hidden_product_price').value,
                    'imageURL': this.shopify.featured_image,
                    'productURL': productUrl
                }]
            };
            this.updateDataLayer(productData);
        },
        getStaticImages() {
            try {
                const allStaticImages = JSON.parse(document.getElementById('product-static-images-metaobject').textContent);
                const wallpaperStaticImages = allStaticImages.filter((image) => {
                    return image.type === 'wallpaper';
                }).sort((a, b) => a.position - b.position);
                this.staticImages = wallpaperStaticImages;
            } catch (e) {
                console.error(e)
            }
        }
    },
}, { ...rootEl.dataset })
const faqsApp = Vue.createApp({
    components: {
        'faqs': Faqs,
    }
});
productApp.use(AdobeClientPlugin).use(store);
productApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('api') && !tag.includes('additional-info') && !tag.includes('materials-compare')
productApp.config.unwrapInjectedRef = true
productApp.config.globalProperties.smallSizeArea = 24;
productApp.config.globalProperties.mediumSizeArea = 62;
productApp.config.globalProperties.largeSizeArea = 96;
productApp.config.globalProperties.minPrice = 10000;
document.addEventListener('DOMContentLoaded', function () {
    productApp.mount('#productApp');
    faqsApp.mount('#faqsApp');
});
